import request, { ResponseData, PagerData } from '@/libs/request/request'
import { DonationQuery } from 'src/api/donation/DonationQuery'
import { Village } from 'src/api/village/Village'

// Donation
export type Donation = {

  createBy?:number

  createByName?:string

  // 创建时间
  createTime?:string

  // 作用
  effect?:string

  // 业务Id
  id?:number

  // 图片链接
  imageUrl?:string

  // 项目名称
  name?:string

  updateBy?:number

  updateByName?:string

  // 更新时间
  updateTime?:string

  // 标题
  version?:number

  // 村子id
  villageId?:number

  // 村庄
  village?:Village
}

export default class DonationService {
  /**
   * 添加一个募捐项目
   * @param {Donation} item 募捐项目实体
   **/
  static addOneDonation (item?:Donation):Promise<ResponseData<Donation>> {
    return request<ResponseData<Donation>>({
      method: 'POST',
      data: item,
      url: '/admin/Donation/Donation'
    })
  }

  /**
   * 更新一个募捐项目
   * @param {Donation} item 募捐项目实体
   **/
  static updateOneDonation (item?:Donation):Promise<ResponseData<Donation>> {
    return request<ResponseData<Donation>>({
      method: 'PUT',
      data: item,
      url: '/admin/Donation/Donation'
    })
  }

  /**
   * 获取募捐项目的分页数据
   * @param {DonationQuery} query 募捐项目实体查询条件
   **/
  static getPagesOfDonation (query?:DonationQuery):Promise<ResponseData<PagerData<Donation>>> {
    return request<ResponseData<PagerData<Donation>>>({
      method: 'POST',
      data: query,
      url: '/admin/Donation/Donation/pages'
    })
  }

  /**
   * 通过id获取一个募捐项目
   * @param {number} id 募捐项目id
   **/
  static getOneDonation (id:number):Promise<ResponseData<Donation>> {
    return request<ResponseData<Donation>>({
      method: 'GET',
      url: `/admin/Donation/Donation/${id}`
    })
  }

  /**
   * 删除一个募捐项目
   * @param {number} id 募捐项目id
   **/
  static deleteOneDonation (id:number):Promise<ResponseData<boolean>> {
    return request<ResponseData<boolean>>({
      method: 'DELETE',
      url: `/admin/Donation/Donation/${id}`
    })
  }
}
